import { supabase } from "../supabase/SupabaseClient";

/* Quién entra al hub, y cuándo fue la última vez.
 *
 * DOS FECHAS PORQUE SON DOS COSAS: `ultimo_login` es la última vez que la
 * persona puso la clave; `ultima_actividad` es la última vez que su sesión se
 * movió (el refresh del token). El que dejó el hub abierto en una pestaña
 * hace dos semanas tiene un login viejo y una actividad de hoy — y la
 * pregunta «¿Gula lo usa?» se contesta con la actividad, no con el login.
 *
 * Los datos viven en `auth.users` / `auth.refresh_tokens`, donde el anon key
 * no llega: por eso es una función (`ultimos_accesos`, SECURITY DEFINER) que
 * adentro exige `ver.sistema` y devuelve vacío a quien no lo tiene.
 */
export async function ultimosAccesos() {
  const { data, error } = await supabase.rpc("ultimos_accesos");
  if (error) throw error;
  return data || [];
}
